export enum Code {
  // 过期
  EXPIRED = 701,
  // 已领取
  RECEIVED = 703,
  // 正常
  NORMAL = 0,
}

export interface RespHeader {
  code: Code
  trace_id: string
  msg: string
  timestamp: number
}

export interface RespGetSurvey {
  conf: {
    id: number
    survey_id: number
    effected_at: number
    expired_at: number
    survey: string
    created_at: number
    updated_at: number
  }
  left_ts: number
}

export interface ActDetailResp {
  conf_id?: string
  question_content?: string
}

export enum QuestionType {
  Title = 'title',
  SingleChoice = 'single_select', // 单选题
  MultipleChoice = 'multi_select', // 多选题
  ImageChoice = 'image_select', // 图片选择题
  FillInTheBlank = 'blank', // 填空题
  RATE = 'star', // 评价题
  Trend = 'trend', // 趋势题
  InformationCollection = 'person', // 信息采集题
}

export const Unique = 'unique'

export enum ErrorCode {
  Necessary = 1001,
  Max = 1002,
  Min = 1003,
  MinText,
}

export enum SubmitStatus {
  // 已领取
  RECEIVED = 1,
  // 未领取
  UNRECEIVED = 0,
}

export enum Nation {
  IN = 'in', // 印度
  ID = 'id', // 印尼
  BR = 'br', // 巴西
  VN = 'vn', // 越南
  PK = 'pk', // 巴基斯坦
  BG = 'bg', // 孟加拉
  NG = 'ng', // 尼日利亚
}
